import Footer from "../../components/Footer";
import Introduction from "../../components/Introduction";
import Navbar from "../../components/Navbar";
import EducationField from "./EducationField";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import "./EducationProgramPage.css";
import Loader from "../../components/Loader";
import Document from "../DocumentsPage/Document.js";

const EducationProgramPage = (props) => {
  let url = `${config.api}/api/${props.education}`;
  if (props.education === "high-school-page") {
    url += `?populate[programs][populate]=timetable&populate[programs][populate]=document&populate[modal][populate]=*&populate[background][populate]=*`;
  } else if (props.education === "primary-school-page") {
    url += `?populate[fieldText][populate]=*&populate[background][populate]=*`;
  }
  //fetch stranky, populate na programy s rozvrhem hodin a modalni okno k zapisu
  const { loading, error, data } = useFetch(url);
  //prettier-ignore
  if (loading) return <Loader />;
  //prettier-ignore
  if (error) return <DefaultPage message="Chyba při načítání vzdělávacího institutu" />;
  //prettier-ignore
  if (!data || !data.data) return <DefaultPage message="Žádné data na stránce" />;

  //? test
  //?console.log(data.data);

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={data.data.title}
        text={data.data.description}
        image={data.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background p-4 p-md-5">
          {/* kontrola jestli je text array a jestli neni null */}
          <BlocksRenderer
            content={Array.isArray(data?.data?.text) ? data.data.text : []}
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>

          <div className="row d-flex flex-wrap justify-content-evenly">
            {data.data.programs?.map((program) => (
              <EducationField
                key={program.id}
                data={program}
                modal={data.data.modal}
                document={program?.document}
              />
            ))}
          </div>
          {data.data?.fieldText && (
            <div className="study-field-container">
              {data.data?.fieldText?.map((fieldText) => (
                <div className="mt-4 mb-5 study-field" key={fieldText.id}>
                  <h2 className="text-center">{fieldText.name}</h2>
                  <BlocksRenderer
                    content={
                      Array.isArray(fieldText?.text) ? fieldText.text : []
                    }
                  ></BlocksRenderer>
                  {fieldText?.documents?.map((document) => (
                    <div className="news-doc" key={document.documentId}>
                      <Document name={document.name} fileUrl={document.url} />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default EducationProgramPage;
